import type { TaskPlan, TaskPlanProgressInput } from "@calcplan/ai-capabilities";

export function planProgressTransitionIssue(plan: TaskPlan, input: TaskPlanProgressInput): string | null {
  const step = plan.steps.find((candidate) => candidate.id === input.stepId);
  if (!step) return `A etapa ${input.stepId} não pertence ao plano ativo.`;
  if (step.status === input.status) return null;

  const completed = new Set(plan.steps
    .filter((candidate) => candidate.status === "completed")
    .map((candidate) => candidate.id));
  const missingDependencies = step.dependsOn.filter((dependency) => !completed.has(dependency));
  if (missingDependencies.length) {
    return `Conclua primeiro as dependências da etapa “${step.title}”: ${missingDependencies.join(", ")}.`;
  }

  const active = plan.steps.find((candidate) => candidate.status === "in_progress");
  if (input.status === "in_progress" && active && active.id !== step.id) {
    return `A etapa ativa é “${active.title}”. Avance nela antes de iniciar “${step.title}”.`;
  }

  // `in_progress` is presentation state, not a transactional prerequisite.
  // Providers commonly batch independent operations and emit their evidence at
  // the end of the batch. Dependencies remain authoritative, while a valid
  // pending -> completed/blocked transition keeps the checklist synchronized
  // with work already performed.
  return null;
}
